export default __webpack_public_path__ + "static/media/frangot-screenshot-03.75f60533.png";